import { render, staticRenderFns } from "./DetalheUploadWhatsapp.vue?vue&type=template&id=202334e4&scoped=true"
import script from "./DetalheUploadWhatsapp.vue?vue&type=script&lang=js"
export * from "./DetalheUploadWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./DetalheUploadWhatsapp.vue?vue&type=style&index=0&id=202334e4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202334e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202334e4')) {
      api.createRecord('202334e4', component.options)
    } else {
      api.reload('202334e4', component.options)
    }
    module.hot.accept("./DetalheUploadWhatsapp.vue?vue&type=template&id=202334e4&scoped=true", function () {
      api.rerender('202334e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DetalheUploadWhatsapp.vue"
export default component.exports